import * as React from 'react'
import { FC, useCallback } from 'react'
import FilterButton from '@user/components/Filters'
import {
  defaultClearedFilters,
  defaultFilters,
  FunnelFilterType,
  SalesFunnelFilterSet,
} from '@user/store/salesFunnelSummary/filters'
import { SalesFunnelFilters } from './SalesFunnelFilters'
import { useSelector } from 'react-redux'
import { selectSalesFunnelFilters } from '@user/store/salesFunnelSummary/slice'
import { useSaveSalesFunnelSummaryFilters } from '@user/store/salesFunnelSummary/hooks/useSaveSalesFunnelSummaryFilters'
import { validateSalesFunnelFilters } from './utils'

export const SalesFunnelFilterButton: FC = () => {
  const filterSet = useSelector(selectSalesFunnelFilters)
  const saveSalesFunnelFilters = useSaveSalesFunnelSummaryFilters()
  const applyCallback = useCallback(
    (model: SalesFunnelFilterSet) => void saveSalesFunnelFilters(model),
    [saveSalesFunnelFilters],
  )

  return (
    <FilterButton<FunnelFilterType, SalesFunnelFilterSet>
      applyCallback={applyCallback}
      defaultValues={defaultFilters}
      clearedValues={defaultClearedFilters}
      filterComponent={SalesFunnelFilters}
      initialValues={filterSet}
      orderOptions={[]}
      hideOrderBy
      validate={validateSalesFunnelFilters}
    />
  )
}

SalesFunnelFilterButton.displayName = 'SalesFunnelFilterButton'
